import { useState, useEffect } from 'react'

export function SwipeHint() {
  const [showHint, setShowHint] = useState(true)

  useEffect(() => {
    // Auto-hide after 4 seconds
    const timer = setTimeout(() => setShowHint(false), 9000)
    return () => clearTimeout(timer)
  }, [])

  if (!showHint) return null

  return (
    <div
      style={{
        position: 'absolute',
        right: '2rem',
        top: '2rem',
        transform: 'translateY(-50%)',
        display: 'flex',
        alignItems: 'center',
        gap: '0.5rem',
        pointerEvents: 'none',
        zIndex: 10
      }}>
      {[0, 1, 2].map((i) => (
        <div
          key={i}
          style={{
            fontSize: '50px',
            color: 'white',
            opacity: 0,
            fontWeight: 100,
            animation: `swipe-hint-fade 3s ease-in-out infinite`,
            animationDelay: `${i * 0.3}s`
          }}>
          ›
        </div>
      ))}
    </div>
  )
}
